<template>
	<svg
		width="20"
		height="18"
		viewBox="0 0 20 18"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.20275 9.44172L1.30163 8.47546C0.884439 8.01534 0.563037 7.48601 0.337422 6.88749C0.112474 6.28969 0 5.65031 0 4.96933C0 3.57055 0.438214 2.39264 1.31464 1.43558C2.1904 0.478528 3.25407 0 4.50563 0C5.07301 0 5.63204 0.124049 6.18273 0.372147C6.73342 0.620982 7.2257 0.984662 7.65957 1.46319L8.5607 2.42945L2.20275 9.44172ZM9.98748 18L3.60451 11.0153L12.3154 1.46319C12.7493 0.984662 13.2459 0.620982 13.8053 0.372147C14.364 0.124049 14.927 0 15.4944 0C16.7292 0 17.7849 0.478528 18.6613 1.43558C19.5371 2.39264 19.9833 3.57055 20 4.96933C20 5.59509 19.8832 6.22086 19.6496 6.84663C19.4159 7.47239 19.0905 8.01534 18.6733 8.47546L9.98748 18Z"
			fill="#181818"
		/>
	</svg>
</template>

<script>
export default {
	name: "HealthIcon",
};
</script>
